// extracted by mini-css-extract-plugin
export var paginationContainer = "_45-0";